import { render, staticRenderFns } from "./FreeTierProjectSections.vue?vue&type=template&id=bd88502c&scoped=true&"
import script from "./FreeTierProjectSections.vue?vue&type=script&lang=js&"
export * from "./FreeTierProjectSections.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd88502c",
  null
  
)

export default component.exports